import { splitOfferCopy } from '@bookora/shared/offers';
import { JalaliDate, Money, Num, Percent } from '@bookora/ui';

import type { ClinicOfferResponse } from '@/api/generated/model';

export type OfferFigures = Pick<
  ClinicOfferResponse,
  | 'percentOffBp'
  | 'amountOffRials'
  | 'capRials'
  | 'freeMonths'
  | 'trialDays'
  | 'smsCreditRials'
  | 'cycles'
  | 'expiresAt'
>;

const percentDecimals = (bp: number): number => (bp % 100 ? (bp % 10 ? 2 : 1) : 0);

/** Renders console-typed offer copy, filling `{token}`s from the offer's own figures. */
export function OfferCopy({ offer, text }: { offer: OfferFigures; text: string }) {
  return (
    <>
      {splitOfferCopy(text).map((part, i) => {
        if (part.kind === 'text') return <span key={i}>{part.value}</span>;
        switch (part.token) {
          case 'percent':
            return offer.percentOffBp ? (
              <Percent
                key={i}
                value={offer.percentOffBp / 100}
                decimals={percentDecimals(offer.percentOffBp)}
              />
            ) : null;
          case 'amount':
            return offer.amountOffRials ? <Money key={i} rials={offer.amountOffRials} /> : null;
          case 'cap':
            return offer.capRials ? <Money key={i} rials={offer.capRials} /> : null;
          case 'smsCredit':
            return offer.smsCreditRials ? <Money key={i} rials={offer.smsCreditRials} /> : null;
          case 'freeMonths':
            return offer.freeMonths ? <Num key={i} value={offer.freeMonths} suffix="ماه" /> : null;
          case 'trialDays':
            return offer.trialDays ? <Num key={i} value={offer.trialDays} suffix="روز" /> : null;
          case 'cycles':
            return offer.cycles ? <Num key={i} value={offer.cycles} /> : null;
          case 'endsAt':
            return offer.expiresAt ? (
              <JalaliDate key={i} value={offer.expiresAt} withRelative={false} />
            ) : null;
          default:
            return null;
        }
      })}
    </>
  );
}
